require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./svgicon"), require("./button"), require("./truncatedtext"), require("./container"), require("./tooltip"), require("./label"), require("./checkbox"), require("./collapse"), require("./radiogroup"), require("./textinput"), require("./toggleswitch"), require("./select"), require("./numberinput"), require("./combobox"), require("./selectgroup"), require("./textarea"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./svgicon", "./button", "./truncatedtext", "./container", "./tooltip", "./label", "./checkbox", "./collapse", "./radiogroup", "./textinput", "./toggleswitch", "./select", "./numberinput", "./combobox", "./selectgroup", "./textarea"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./svgicon"), require("./button"), require("./truncatedtext"), require("./container"), require("./tooltip"), require("./label"), require("./checkbox"), require("./collapse"), require("./radiogroup"), require("./textinput"), require("./toggleswitch"), require("./select"), require("./numberinput"), require("./combobox"), require("./selectgroup"), require("./textarea")) : factory(root["./utils"], root["./svgicon"], root["./button"], root["./truncatedtext"], root["./container"], root["./tooltip"], root["./label"], root["./checkbox"], root["./collapse"], root["./radiogroup"], root["./textinput"], root["./toggleswitch"], root["./select"], root["./numberinput"], root["./combobox"], root["./selectgroup"], root["./textarea"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__16__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__37__, __WEBPACK_EXTERNAL_MODULE__41__, __WEBPACK_EXTERNAL_MODULE__42__, __WEBPACK_EXTERNAL_MODULE__46__, __WEBPACK_EXTERNAL_MODULE__47__, __WEBPACK_EXTERNAL_MODULE__48__, __WEBPACK_EXTERNAL_MODULE__49__, __WEBPACK_EXTERNAL_MODULE__79__, __WEBPACK_EXTERNAL_MODULE__80__, __WEBPACK_EXTERNAL_MODULE__81__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[45],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__10__;

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__12__;

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__13__;

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".tooltip-position{position:absolute;right:0;top:.8rem}.ba-common-collapsibleSection .is-large .ba-common-propertiesPane__children{justify-content:flex-end}.ba-common-propertiesPane{min-height:40px;position:relative}.ba-common-propertiesPane__inner{display:grid;width:100%;grid-gap:8px;grid-template-areas:\"ba-common-propertiesPane__label ba-common-propertiesPane__children\";grid-template-columns:1fr 1fr 1fr 1fr;-ms-grid-template-columns:1fr 8px 1fr 8px 1fr 8px 1fr}.ba-common-propertiesPane__inner.is-column{grid-gap:0;grid-template-columns:none;-ms-grid-columns:1fr;grid-template-areas:\"ba-common-propertiesPane__label\" \"ba-common-propertiesPane__children\";-ms-grid-template-rows:1fr 1fr}.ba-common-propertiesPane__inner.is-column .ba-common-propertiesPane__label{justify-content:flex-start;-ms-grid-row:1;-ms-grid-column:1;-ms-grid-column-span:4}.ba-common-propertiesPane__inner.is-column .ba-common-propertiesPane__children{justify-content:flex-start;-ms-grid-row:2;-ms-grid-column:1;-ms-grid-column-span:4}.ba-common-propertiesPane__inner.is-small .ba-common-propertiesPane__label{grid-column:1/2;-ms-grid-column:1;-ms-grid-column-span:1}.ba-common-propertiesPane__inner.is-small .ba-common-propertiesPane__children{grid-column:2/5;-ms-grid-column:2;-ms-grid-column-span:3}.ba-common-propertiesPane__inner.is-medium .ba-common-propertiesPane__label{grid-column:1/3;-ms-grid-column:1;-ms-grid-column-span:2}.ba-common-propertiesPane__inner.is-medium .ba-common-propertiesPane__children{grid-column:3/5;-ms-grid-column:3;-ms-grid-column-span:2}.ba-common-propertiesPane__inner.is-large .ba-common-propertiesPane__label{grid-column:1/4;-ms-grid-column:1;-ms-grid-column-span:3}.ba-common-propertiesPane__inner.is-large .ba-common-propertiesPane__children{grid-column:4/5;-ms-grid-column:4;-ms-grid-column-span:1}.ba-common-propertiesPane__inner .ba-common-propertiesPane__label{display:flex;flex-direction:column}.ba-common-propertiesPane__inner .ba-common-propertiesPane__children{display:flex;align-items:center;justify-content:flex-start}.ba-common-propertiesPane__inner .ba-common-propertiesPane__children.is-flexEnd{justify-content:flex-end}.ba-common-propertiesPane__inner .ba-common-button:not(.is-disabled) *:hover{cursor:pointer}.ba-common-propertiesPane__inner .ba-common-button.is-disabled *:hover{cursor:not-allowed}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner .ba-common-propertiesPane__children{grid-row:1;justify-content:flex-start}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-column{grid-template-columns:none;-ms-grid-columns:1fr;grid-template-areas:\"ba-common-propertiesPane__label\" \"ba-common-propertiesPane__children\";-ms-grid-template-rows:1fr 1fr}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-column .ba-common-propertiesPane__label{grid-row:1;justify-content:flex-end;-ms-grid-row:1;-ms-grid-column:1;-ms-grid-column-span:4}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-column .ba-common-propertiesPane__children{grid-row:2;justify-content:flex-end;-ms-grid-row:2;-ms-grid-column:1;-ms-grid-column-span:4}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-small .ba-common-propertiesPane__label{grid-column:4/5;-ms-grid-column:4;-ms-grid-column-span:1}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-small .ba-common-propertiesPane__children{grid-column:1/4;-ms-grid-column:1;-ms-grid-column-span:3}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-medium .ba-common-propertiesPane__label{grid-column:3/5;-ms-grid-column:3;-ms-grid-column-span:2}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-medium .ba-common-propertiesPane__children{grid-column:1/3;-ms-grid-column:1;-ms-grid-column-span:2}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-large .ba-common-propertiesPane__label{grid-column:2/5;-ms-grid-column:2;-ms-grid-column-span:3}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner.is-large .ba-common-propertiesPane__children{grid-column:1/2;-ms-grid-column:1;-ms-grid-column-span:1}.ba-common-propertiesPane.is-rtl .ba-common-propertiesPane__inner .ba-common-propertiesPane__iconPosition{margin-left:8px;margin-right:0px}.ba-common-propertiesPane__iconPosition{margin-right:8px;margin-left:0px;align-items:center}.ba-common-propertiesPane__iconPosition .ba-common-propertiesPane__icon{height:32px}.ba-common-propertiesPane__labelContent{display:flex;flex-direction:row;min-height:40px;align-items:center;justify-content:flex-start}.ba-common-propertiesPane__labelContent.is-rtl{flex-direction:row-reverse}.ba-common-propertiesPane__labelContent .ba-common-label{line-height:20px}.ba-common-propertiesPane__labelContent>*{margin-right:8px}.ba--highContrast .ba-common-propertiesPane.is-header{outline:1px inset transparent}.ba-common-propertiesPane{transition:color .2s ease-in-out;background-color:#fff}.ba-common-propertiesPane.is-header{color:#1f57a4;background-color:#f6f6f6}.ba-common-propertiesPane__icon{transition:opacity .2s ease-in-out}.ba-common-propertiesPane__icon.is-disabled{opacity:.5}", ""]);

// exports
exports.locals = {
	"propertiesPaneClassName": "\"ba-common-propertiesPane\""
};

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-propertyPanel{font-size:14px;display:flex;flex-direction:column;background:#fff;min-width:400px;padding:0 24px;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,.1)}.ba-common-propertyPanel__panelTitle{line-height:48px;width:100%;font-weight:600;vertical-align:middle}.ba-common-propertyPanel .ba-common-tabList{height:40px;margin-bottom:24px}.ba-common-propertyPanel .ba-common-tabList__inner{padding:0}.ba-common-propertyPanel__buttonSection{display:flex;height:64px;align-items:center;flex-direction:row-reverse}.ba-common-propertyPanel__buttonSection__rightButton{align-self:flex-end}", ""]);

// exports
exports.locals = {
	"propertyPanelClassName": "\"ba-common-propertyPanel\""
};

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-labelSection{display:flex;align-items:center;min-height:40px;width:100%}.ba-common-labelSection .ba-common-label{font-weight:600}.ba-common-labelSection.is-sectionHeader .ba-common-label{font-weight:600}.ba-common-labelSection.is-rtl .ba-common-truncatedText{text-align:left}.ba-common-labelSection .ba-common-truncatedText{text-align:right}.ba-common-textInputSection{text-align:left !important}.ba-common-textInputSection .ba-common-baseInput{height:32px}.ba-common-textInputSection .ba-common-baseInput input{height:32px}.ba-common-numberSection{text-align:left !important}.ba-common-numberSection .ba-common-baseInput{height:32px}.ba-common-numberSection .ba-common-baseInput input{height:32px}.ba-common-checkboxSection .ba-common-checkbox.is-right input{right:0}.ba-common-checkboxSection .ba-common-checkbox__box{margin-top:-2px}.ba-common-selectSection .ba-common-select{width:100%}.ba-common-selectSection .ba-common-select__wrapper{width:100%}.ba-common-selectSection .ba-common-select .ba-common-button{min-width:0}.ba-common-selectSection .ba-common-select .ba-common-toolTip{display:block !important}.ba-common-selectSection .ba-common-select .ba-common-truncatedText__text{line-height:20px}.ba-common-selectSection .ba-common-select .ba-common-selectGroup{width:100%}.ba-common-selectSection .ba-common-selectGroup{padding:4px 0;width:100%}.ba-common-linkSection.is-rtl .ba-common-truncatedText{text-align:left}.ba-common-linkSection .ba-common-truncatedText{text-align:right}.ba-common-textAreaSection .ba-common-textArea>textarea{margin-top:0}.ba-common-comboboxSection .ba-common-combobox{min-width:80px !important;width:100% !important;height:32px}.ba-common-comboboxSection .ba-common-combobox .ba-common-baseInput{width:100%;border-left:0;border-right:0;height:32px}.ba-common-comboboxSection .ba-common-combobox .ba-common-baseInput input{height:32px}.ba-common-collapsibleSection .ba-common-propertiesPane:first-child{padding-top:0}.ba-common-collapsibleSection .ba-common-propertiesPane .ba-common-button:first-of-type{padding:0 8px}.ba-common-collapsibleSection__trigger-button{color:inherit;margin-right:0px;margin-top:4px;min-width:100%}.ba-common-collapsibleSection__trigger-button:hover{color:inherit}.ba-common-collapsibleSection__trigger-button.bx--btn--ghost.bx--btn--field{outline:none;padding-left:0px}.ba-common-radioSection .ba-radioGroup.is-vertical.is-right{align-items:flex-end}.ba-common-radioSection .ba-radioGroup.is-vertical.is-left{align-items:flex-start}.ba-common-radioSection .ba-radioGroup__item .ba-radio{flex-direction:row}.ba-common-radioSection .ba-radioGroup__item .ba-radio.is-left .ba-radio__label{padding-left:8px;padding-right:0}.ba-common-radioSection .ba-radioGroup__item .ba-radio.is-right .ba-radio__label{padding-right:8px;padding-left:0}.ba-common-textSection{height:20px}.ba-common-textSection .ba-common-truncatedText{text-align:right}.ba-common-textSection .ba-common-truncatedText__text{line-height:20px}.ba-common-textSection.is-rtl .ba-common-truncatedText{text-align:left}.ba-common-combobox__wrapper .ba-common-combobox__icon{transition:none;color:#595859}.ba-common-textSection.is-disabled .ba-common-truncatedText{opacity:1}.ba-common-textSection.is-disabled .ba-common-truncatedText__text{opacity:.5}", ""]);

// exports
exports.locals = {
	"labelSectionClassName": "\"ba-common-labelSection\"",
	"textInputSectionClassName": "\"ba-common-textInputSection\"",
	"selectSectionClassName": "\"ba-common-selectSection\"",
	"textAreaSectionClassName": "\"ba-common-textAreaSection\"",
	"collapsibleSectionClassName": "\"ba-common-collapsibleSection\"",
	"radioSectionClassName": "\"ba-common-radioSection\"",
	"textSectionClassName": "\"ba-common-textSection\"",
	"checkboxSectionClassName": "\"ba-common-checkboxSection\"",
	"linkSectionClassName": "\"ba-common-linkSection\"",
	"comboboxSectionClassName": "\"ba-common-comboboxSection\"",
	"numberInputSectionClassName": "\"ba-common-numberSection\""
};

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__16__;

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__17__;

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _container = _interopRequireDefault(__webpack_require__(15));

var _label = _interopRequireDefault(__webpack_require__(17));

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(436));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
// TODO build out clickRelay component?
// import ClickRelay from '../controls/ClickRelay';
const propertiesPaneClassName = _PropertiesPane.default.propertiesPaneClassName.replace(/"/g, '');

const {
  sanitize,
  BaPropTypes
} = _utils.propsUtils;

class PropertiesPane extends _react.Component {
  _onClick(labelAction) {
    return e => {
      labelAction && e.preventDefault();
    };
  }

  _isLabelAction() {
    const {
      children
    } = this.props;
    let labelAction;
    let child;

    try {
      child = _react.default.Children.only(children).type; // prevent dropdown focusing on label click
      // eslint-disable-next-line no-underscore-dangle

      labelAction = child.__Select__ || child.__ComboBox__ || child.__SelectGroup__ || false;
    } catch (err) {
      labelAction = false;
    }

    return labelAction;
  }

  render() {
    const {
      icon,
      label,
      htmlFor,
      labelId,
      disabled,
      rtl,
      dataLabel,
      children,
      childrenAlignEnd,
      className,
      style,
      labelStyle,
      labelSize,
      validationNode,
      descriptionNode,
      changeIndicatorNode,
      ...others
    } = this.props;
    const isColumn = labelSize === 'full';

    const labelAction = this._isLabelAction();

    let iconComponent;
    const iconType = typeof icon;

    if (iconType !== 'undefined') {
      // will be deprecated
      iconComponent = /*#__PURE__*/_react.default.createElement("span", {
        className: `${propertiesPaneClassName}__iconPosition`
      }, iconType === 'string' ? /*#__PURE__*/_react.default.createElement(_svgicon.default, {
        className: (0, _utils.classnames)(`${propertiesPaneClassName}__icon`),
        disabled: disabled,
        iconId: icon,
        size: "small"
      }) : icon);
    }

    let labelContent = /*#__PURE__*/_react.default.createElement("div", {
      className: `${propertiesPaneClassName}__labelContent ${(0, _utils.classnames)({
        rtl
      })}`
    }, iconComponent, typeof label === 'string' ? /*#__PURE__*/_react.default.createElement(_label.default, {
      onClick: this._onClick(labelAction),
      htmlFor: htmlFor,
      label: label,
      disabled: disabled,
      ellipsis: dataLabel,
      style: labelStyle
    }) : label);

    if (validationNode || descriptionNode || changeIndicatorNode) {
      labelContent = /*#__PURE__*/_react.default.createElement("div", {
        className: `${propertiesPaneClassName}__labelContent ${(0, _utils.classnames)({
          rtl
        })}`
      }, validationNode, descriptionNode, typeof label === 'string' ? /*#__PURE__*/_react.default.createElement(_label.default, {
        onClick: this._onClick(labelAction),
        htmlFor: htmlFor,
        label: label,
        disabled: disabled,
        ellipsis: dataLabel,
        style: labelStyle
      }) : label, changeIndicatorNode);
    }

    const classNames = (0, _utils.classnames)(propertiesPaneClassName, {
      rtl
    });
    return /*#__PURE__*/_react.default.createElement(_container.default, (0, _extends2.default)({}, sanitize(others, PropertiesPane), {
      padding: [0, 0],
      className: `${classNames} ${className}`,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_container.default, {
      className: (0, _utils.classnames)(`${propertiesPaneClassName}__inner`, labelSize, isColumn ? 'column' : '')
    }, /*#__PURE__*/_react.default.createElement(_container.default, {
      className: (0, _utils.classnames)(`${propertiesPaneClassName}__label`),
      id: labelId
    }, labelContent), /*#__PURE__*/_react.default.createElement(_container.default, {
      className: (0, _utils.classnames)(`${propertiesPaneClassName}__children`, {
        flexEnd: childrenAlignEnd
      })
    }, children)));
  }

}

exports.default = PropertiesPane;
(0, _defineProperty2.default)(PropertiesPane, "propTypes", {
  icon: BaPropTypes.deprecated('It will be removed soon, use "validationRenderer", "descriptionRenderer", "changeRenderer" instead'),
  validationNode: _propTypes.default.node,
  descriptionNode: _propTypes.default.node,
  changeIndicatorNode: _propTypes.default.node,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  htmlFor: _propTypes.default.string,
  className: _propTypes.default.string,
  labelId: _propTypes.default.string,
  style: _propTypes.default.object,
  labelStyle: _propTypes.default.object,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  disabled: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  dataLabel: _propTypes.default.bool,
  children: _propTypes.default.node,
  childrenAlignEnd: _propTypes.default.bool
});
(0, _defineProperty2.default)(PropertiesPane, "defaultProps", {
  labelSize: 'medium',
  className: '',
  style: {},
  labelStyle: {}
});

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(138);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_SectionStyles_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__37__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__41__;

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__42__;

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(435);


/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

exports.default = _PropertiesPane.default;
exports.PropertiesPane = _PropertiesPane.default;

var _PropertyPanel = _interopRequireDefault(__webpack_require__(437));

exports.PropertyPanel = _PropertyPanel.default;

var _TextSection = _interopRequireDefault(__webpack_require__(439));

exports.TextSection = _TextSection.default;

var _CheckboxSection = _interopRequireDefault(__webpack_require__(440));

exports.CheckboxSection = _CheckboxSection.default;

var _ComboboxSection = _interopRequireDefault(__webpack_require__(441));

exports.ComboboxSection = _ComboboxSection.default;

var _ToggleSwitchSection = _interopRequireDefault(__webpack_require__(442));

exports.ToggleSwitchSection = _ToggleSwitchSection.default;

var _RadioSection = _interopRequireDefault(__webpack_require__(443));

exports.RadioSection = _RadioSection.default;

var _SelectSection = _interopRequireDefault(__webpack_require__(444));

exports.SelectSection = _SelectSection.default;

var _MultiSelectSection = _interopRequireDefault(__webpack_require__(445));

exports.MultiSelectSection = _MultiSelectSection.default;

var _TextAreaSection = _interopRequireDefault(__webpack_require__(446));

exports.TextAreaSection = _TextAreaSection.default;

var _TextInputSection = _interopRequireDefault(__webpack_require__(447));

exports.TextInputSection = _TextInputSection.default;

var _NumberInputSection = _interopRequireDefault(__webpack_require__(448));

exports.NumberInputSection = _NumberInputSection.default;

var _CollapsibleSection = _interopRequireDefault(__webpack_require__(449));

exports.CollapsibleSection = _CollapsibleSection.default;

var _LabelSection = _interopRequireDefault(__webpack_require__(450));

exports.LabelSection = _LabelSection.default;

var _LinkSection = _interopRequireDefault(__webpack_require__(451));

exports.LinkSection = _LinkSection.default;

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(136);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PropertiesPane_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _container = _interopRequireDefault(__webpack_require__(15));

var _label = _interopRequireDefault(__webpack_require__(17));

var _utils = __webpack_require__(5);

var _PropertyPanel = _interopRequireDefault(__webpack_require__(438));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const propertyPanelClassName = _PropertyPanel.default.propertyPanelClassName.replace(/"/g, '');

const {
  sanitize
} = _utils.propsUtils;

class PropertyPanel extends _react.Component {
  render() {
    const {
      title,
      className,
      isResizable,
      children,
      buttons,
      style,
      ...others
    } = this.props;

    const titleSection = /*#__PURE__*/_react.default.createElement(_label.default, {
      "data-tid": "ba-common-property-panel__title-section",
      className: `${propertyPanelClassName}__panelTitle`,
      label: title
    });

    const childrenContent = /*#__PURE__*/_react.default.createElement(_container.default, {
      "data-tid": "ba-common-property-panel__content-section"
    }, children);

    const buttonsSection = buttons ? /*#__PURE__*/_react.default.createElement(_container.default, {
      "data-tid": "ba-common-property-panel__button-section",
      className: `${propertyPanelClassName}__buttonSection`
    }, buttons) : '';
    const classNames = (0, _utils.classnames)(propertyPanelClassName);
    return /*#__PURE__*/_react.default.createElement(_container.default, (0, _extends2.default)({}, sanitize(others, PropertyPanel), {
      className: `${classNames} ${className}`,
      resizable: isResizable,
      style: style
    }), titleSection, childrenContent, buttonsSection);
  }

}

exports.default = PropertyPanel;
(0, _defineProperty2.default)(PropertyPanel, "propTypes", {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  className: _propTypes.default.string,
  // children:
  // Tabs -> TabPanels -> PropertySections
  // PropertySections
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array]),
  buttons: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array]),
  rtl: _propTypes.default.bool,
  isResizable: _propTypes.default.bool,
  style: _propTypes.default.object
});
(0, _defineProperty2.default)(PropertyPanel, "defaultProps", {
  className: '',
  style: {},
  title: ''
});

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(137);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ref_5_2_PropertyPanel_scss__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _truncatedtext = _interopRequireDefault(__webpack_require__(13));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

var _SectionStyles = _interopRequireDefault(__webpack_require__(20));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const textSectionClassName = _SectionStyles.default.textSectionClassName.replace(/"/g, '');

const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
const {
  omit
} = _utils.lodash;

class TextSection extends _react.Component {
  render() {
    const {
      label,
      title,
      text,
      disabled,
      readOnly,
      rtl,
      labelSize,
      textAlign,
      className,
      style,
      ...others
    } = this.props;
    const classNames = (0, _utils.classnames)(textSectionClassName, rtl);
    const {
      propertiesPanePassthroughProps,
      others: truncatedTextPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, TextSection), propertiesPanePassthroughProps, {
      className: `${classNames} ${className}`,
      label: label,
      title: title,
      rtl: rtl,
      labelSize: labelSize,
      disabled: disabled,
      style: style
    }), /*#__PURE__*/_react.default.createElement("div", {
      "data-tid": "ba-common-text-section__truncated-text",
      className: (0, _utils.classnames)({
        disabled: disabled || readOnly
      })
    }, /*#__PURE__*/_react.default.createElement(_truncatedtext.default, (0, _extends2.default)({}, truncatedTextPassthroughProps, {
      value: text,
      textAlign: textAlign
    }))));
  }

}

exports.default = TextSection;
(0, _defineProperty2.default)(TextSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  text: _propTypes.default.string.isRequired,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  textAlign: _propTypes.default.oneOf(['left', 'right', 'center']),
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  resizable: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  truncateFullCount: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ...omit(_truncatedtext.default.propTypes, 'value'),
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(TextSection, "defaultProps", {
  truncateFullCount: false,
  className: '',
  style: {}
});

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _checkbox = _interopRequireDefault(__webpack_require__(37));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

var _SectionStyles = _interopRequireDefault(__webpack_require__(20));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const checkboxSectionClassName = _SectionStyles.default.checkboxSectionClassName.replace(/"/g, '');

const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps,
  BaPropTypes
} = _utils.propsUtils;

class CheckboxSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__checkboxSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }

  render() {
    const {
      label,
      title,
      checked,
      indeterminate,
      disabled,
      readOnly,
      rtl,
      onChange,
      labelSize,
      className,
      style,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: checkboxPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);

    const checkbox = /*#__PURE__*/_react.default.createElement(_checkbox.default, (0, _extends2.default)({}, checkboxPassthroughProps, {
      "data-tid": `ba-common-checkbox-section__${this._id}-checkbox`,
      align: rtl ? 'right' : 'left',
      checked: checked,
      indeterminate: indeterminate,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      id: this._id,
      "aria-labelledby": this._propLabelId
    }));

    const classnames = (0, _utils.classnames)(checkboxSectionClassName);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, CheckboxSection), propertiesPanePassthroughProps, {
      className: `${classnames} ${className}`,
      label: label,
      title: title,
      labelSize: labelSize,
      labelId: this._propLabelId,
      disabled: disabled,
      htmlFor: this._id,
      rtl: rtl,
      style: style
    }), checkbox);
  }

}

exports.default = CheckboxSection;
(0, _defineProperty2.default)(CheckboxSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  checked: _propTypes.default.bool,
  indeterminate: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._checkbox.default.propTypes,
  ..._PropertiesPane.default.propTypes,
  labelSize: BaPropTypes.deprecated('It will be removed soon, Checkbox width is non-negotiable')
});
(0, _defineProperty2.default)(CheckboxSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _combobox = _interopRequireDefault(__webpack_require__(79));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

var _SectionStyles = _interopRequireDefault(__webpack_require__(20));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const comboboxSectionClassName = _SectionStyles.default.comboboxSectionClassName.replace(/"/g, '');

const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;

class ComboboxSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__ComboboxSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }

  render() {
    const {
      label,
      title,
      labelSize,
      disabled,
      rtl,
      className,
      style,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: comboBoxPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, ComboboxSection), propertiesPanePassthroughProps, {
      className: `${comboboxSectionClassName} ${className}`,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      label: label,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_combobox.default, (0, _extends2.default)({}, comboBoxPassthroughProps, {
      id: this._id,
      "aria-labelledby": this._propLabelId,
      "data-tid": "ba-common-combox-section__combox",
      disabled: disabled
    })));
  }

}

exports.default = ComboboxSection;
(0, _defineProperty2.default)(ComboboxSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  disabled: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._combobox.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(ComboboxSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _toggleswitch = _interopRequireDefault(__webpack_require__(47));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;

class ToggleSwitchSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__toggleSwitchSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }

  render() {
    const {
      label,
      title,
      checked,
      disabled,
      readOnly,
      rtl,
      onChange,
      className,
      style,
      small,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: toggleSwitchPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, ToggleSwitchSection), propertiesPanePassthroughProps, {
      className: className,
      label: label,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_toggleswitch.default, (0, _extends2.default)({}, toggleSwitchPassthroughProps, {
      id: this._id,
      "aria-labelledby": this._propLabelId,
      "data-tid": "ba-common-toggleswitch-section__toggleswitch",
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      small: small != null ? small : true
    })));
  }

}

exports.default = ToggleSwitchSection;
(0, _defineProperty2.default)(ToggleSwitchSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._toggleswitch.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(ToggleSwitchSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _radiogroup = _interopRequireDefault(__webpack_require__(42));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

var _SectionStyles = _interopRequireDefault(__webpack_require__(20));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const radioSectionClassName = _SectionStyles.default.radioSectionClassName.replace(/"/g, '');

const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;

class RadioSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__radioSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }

  render() {
    const {
      label,
      title,
      checked,
      disabled,
      readOnly,
      rtl,
      options,
      onChange,
      labelSize,
      className,
      style,
      ...others
    } = this.props;
    const align = this.props.align || rtl ? 'right' : 'left';
    const {
      propertiesPanePassthroughProps,
      others: radioGroupPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others), propertiesPanePassthroughProps, {
      className: `${radioSectionClassName} ${className}`,
      labelSize: labelSize,
      label: label,
      title: title,
      disabled: disabled,
      rtl: rtl,
      htmlFor: this._id,
      labelId: this._propLabelId,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_radiogroup.default, (0, _extends2.default)({}, radioGroupPassthroughProps, {
      "data-tid": "ba-common-radio-section__radio-group",
      "aria-labelledby": this._propLabelId,
      selectedId: this._id,
      direction: "vertical",
      align: align,
      checked: checked,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      options: options
    })));
  }

}

exports.default = RadioSection;
(0, _defineProperty2.default)(RadioSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  align: _propTypes.default.oneOf(['left', 'right']),
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  options: _propTypes.default.array.isRequired,
  checked: _propTypes.default.any,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._radiogroup.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(RadioSection, "defaultProps", {
  labelSize: 'full',
  className: '',
  style: {}
});

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _select = _interopRequireDefault(__webpack_require__(48));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

var _SectionStyles = _interopRequireDefault(__webpack_require__(20));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const selectSectionClassName = _SectionStyles.default.selectSectionClassName.replace(/"/g, '');

const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;

class SelectSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__selectSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }

  render() {
    const {
      label,
      title,
      selected,
      options,
      disabled,
      rtl,
      textDir,
      onChange,
      readOnly,
      labelSize,
      displayLabel,
      className,
      style,
      light,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: selectPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, SelectSection), propertiesPanePassthroughProps, {
      className: `${selectSectionClassName} ${className}`,
      label: label,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_select.default, (0, _extends2.default)({}, sanitize(selectPassthroughProps, null, 'icon'), {
      // {...selectPassthroughProps}// TODO: uncomment this line and remove next line when icon is deprecated
      "data-tid": "ba-common-select-section__select",
      "aria-labelledby": this._propLabelId,
      size: "small",
      id: this._id,
      selected: selected,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      displayLabel: displayLabel,
      options: options,
      textDir: textDir,
      light: light != null ? light : true
    })));
  }

}

exports.default = SelectSection;
(0, _defineProperty2.default)(SelectSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  displayLabel: _propTypes.default.string,
  // Used for empty placeholder state of select. Will not be shown if passed a Selected prop
  title: _propTypes.default.string,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  // CSS Grid layout 1/4, 1/2, 3/4, full widths
  selected: _propTypes.default.any.isRequired,
  options: _propTypes.default.array.isRequired,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  onChange: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._select.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(SelectSection, "defaultProps", {
  className: '',
  style: {},
  selected: []
});

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _selectgroup = _interopRequireDefault(__webpack_require__(80));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

var _SectionStyles = _interopRequireDefault(__webpack_require__(20));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const selectSectionClassName = _SectionStyles.default.selectSectionClassName.replace(/"/g, '');

const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;

class SelectGroupSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__multiSelectSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }

  render() {
    const {
      options,
      label,
      title,
      selected,
      disabled,
      readOnly,
      rtl,
      onChange,
      labelSize,
      className,
      style,
      light,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: selectGroupPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, SelectGroupSection), propertiesPanePassthroughProps, {
      className: `${selectSectionClassName} ${className}`,
      label: label,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_selectgroup.default, (0, _extends2.default)({}, sanitize(selectGroupPassthroughProps, null, 'icon'), {
      // {...selectGroupPassthroughProps}// TODO: uncomment this line and remove next line when icon is deprecated
      "data-tid": "ba-common-select-group-section__select-group",
      "aria-labelledby": this._propLabelId,
      lastId: this._id,
      size: "small",
      align: rtl ? 'left' : 'right',
      orient: rtl ? 'bottom-right' : 'bottom-left',
      selected: selected,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      options: options,
      light: light != null ? light : true
    })));
  }

}

exports.default = SelectGroupSection;
(0, _defineProperty2.default)(SelectGroupSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  options: _propTypes.default.object.isRequired,
  selected: _propTypes.default.array.isRequired,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._selectgroup.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(SelectGroupSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _information_ = _interopRequireDefault(__webpack_require__(75));

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _textarea = _interopRequireDefault(__webpack_require__(81));

var _tooltip = _interopRequireDefault(__webpack_require__(16));

var _SectionStyles = _interopRequireDefault(__webpack_require__(20));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;

const textAreaSectionClassName = _SectionStyles.default.textAreaSectionClassName.replace(/"/g, ''); // eslint-disable-line no-unused-vars


class TextAreaSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__textAreaSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }

  render() {
    const {
      label,
      tooltipText,
      title,
      placeholder,
      rows,
      value,
      disabled,
      rtl,
      fireOnBlur,
      onChange,
      readOnly,
      className,
      labelSize,
      style,
      light,
      ...others
    } = this.props;
    const classNames = (0, _utils.classnames)(textAreaSectionClassName);
    const {
      propertiesPanePassthroughProps,
      others: textAreaPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, TextAreaSection), propertiesPanePassthroughProps, {
      className: `${classNames} ${className}`,
      label: label,
      title: title,
      disabled: disabled,
      labelSize: labelSize,
      htmlFor: this._id,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), tooltipText && /*#__PURE__*/_react.default.createElement("div", {
      className: "tooltip-position"
    }, /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: tooltipText,
      orient: "left"
    }, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      icon: _information_.default.id
    }))), /*#__PURE__*/_react.default.createElement(_textarea.default, (0, _extends2.default)({}, textAreaPassthroughProps, {
      "aria-labelledby": this._propLabelId,
      "data-tid": "ba-common-textarea-section__textarea",
      id: this._id,
      value: value,
      rows: rows,
      onChange: onChange,
      disabled: disabled,
      readOnly: readOnly,
      placeholder: placeholder,
      fireOnBlur: fireOnBlur,
      light: light != null ? light : true
    })));
  }

}

exports.default = TextAreaSection;
(0, _defineProperty2.default)(TextAreaSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  className: _propTypes.default.string,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  tooltipText: _propTypes.default.string,
  rows: _propTypes.default.number,
  fireOnBlur: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  style: _propTypes.default.object,
  ..._textarea.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(TextAreaSection, "defaultProps", {
  labelSize: 'full',
  className: '',
  style: {}
});

/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _textinput = _interopRequireDefault(__webpack_require__(46));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

var _SectionStyles = _interopRequireDefault(__webpack_require__(20));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const textInputSectionClassName = _SectionStyles.default.textInputSectionClassName.replace(/"/g, '');

const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;

class TextInputSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__textInputSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }

  render() {
    const {
      'data-tid': dataTid,
      label,
      title,
      placeholder,
      value,
      textAlign,
      disabled,
      rtl,
      fireOnBlur,
      onChange,
      readOnly,
      labelSize,
      className,
      style,
      textDir,
      light,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: textInputPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    const inputProps = {
      id: this._id,
      fullWidth: true,
      textAlign,
      placeholder,
      value,
      onChange,
      disabled,
      readOnly,
      fireOnBlur
    };
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, TextInputSection), propertiesPanePassthroughProps, {
      "data-tid": dataTid,
      className: `${textInputSectionClassName} ${className}`,
      label: label,
      title: title,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      rtl: rtl,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_textinput.default // {...textInputPassthroughProps}// TODO: uncomment this line and remove the next two lines when icon is deprecated
    , (0, _extends2.default)({}, sanitize(textInputPassthroughProps, null, 'icon'), {
      "data-tid": "ba-common-textinput-section__textinput",
      "aria-labelledby": this._propLabelId,
      textDir: textDir
    }, inputProps, {
      className: "textInputSection",
      light: light != null ? light : true
    })));
  }

}

exports.default = TextInputSection;
(0, _defineProperty2.default)(TextInputSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  textAlign: _propTypes.default.oneOf(['left', 'right']),
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  fireOnBlur: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._textinput.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(TextInputSection, "defaultProps", {
  textAlign: 'left',
  className: '',
  style: {}
});

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _numberinput = _interopRequireDefault(__webpack_require__(49));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

var _SectionStyles = _interopRequireDefault(__webpack_require__(20));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const numberInputSectionClassName = _SectionStyles.default.numberInputSectionClassName.replace(/"/g, '');

const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;

class NumberInputSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__numberInputSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }

  render() {
    const {
      title,
      light,
      disabled,
      ...others
    } = this.props;
    const {
      propertiesPanePassthroughProps,
      others: numberInputPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    const inputProps = {
      id: this._id,
      fullWidth: true
    };
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, propertiesPanePassthroughProps, {
      title: title,
      htmlFor: this._id,
      labelId: this._propLabelId,
      className: `${numberInputSectionClassName}`,
      disabled: disabled
    }), /*#__PURE__*/_react.default.createElement(_numberinput.default // {...numberInputPassthroughProps}// TODO: uncomment this line and remove next line when icon is deprecated
    , (0, _extends2.default)({}, sanitize(numberInputPassthroughProps, null, 'icon'), inputProps, {
      "data-tid": "ba-common-numberinput-section__numberinput",
      "aria-labelledby": this._propLabelId,
      className: "numberInputSection",
      light: light != null ? light : true,
      disabled: disabled
    })));
  }

}

exports.default = NumberInputSection;
(0, _defineProperty2.default)(NumberInputSection, "propTypes", {
  title: _propTypes.default.string,
  ...sanitize(_numberinput.default.propTypes, null, 'fullWidth'),
  ..._PropertiesPane.default.propTypes
});

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _button = _interopRequireDefault(__webpack_require__(12));

var _collapse = _interopRequireDefault(__webpack_require__(41));

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _chevronRight_ = _interopRequireDefault(__webpack_require__(60));

var _container = _interopRequireDefault(__webpack_require__(15));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

var _SectionStyles = _interopRequireDefault(__webpack_require__(20));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const collapsibleSectionClassName = _SectionStyles.default.collapsibleSectionClassName.replace(/"/g, ''); // eslint-disable-line no-unused-vars


const {
  uniqueId,
  omit
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;
const {
  getKeyName,
  keyNames
} = _utils.keyboardUtils;

class CollapsibleSection extends _react.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "_toggleOpen", () => {
      const {
        open,
        onOpen
      } = this.props;

      if (typeof open === 'undefined') {
        this.setState(state => ({
          open: !state.open
        }));
      }

      onOpen && onOpen(!open);
    });
    (0, _defineProperty2.default)(this, "_onKeyDown", e => {
      const {
        open
      } = this.state;

      switch (getKeyName(e)) {
        case keyNames.LEFT:
        case keyNames.UP:
          e.preventDefault();

          if (open) {
            this._toggleOpen();
          }

          break;

        case keyNames.RIGHT:
        case keyNames.DOWN:
          e.preventDefault();

          if (!open) {
            this._toggleOpen();
          }

          break;

        default:
      }
    });
    this.state = {
      open: !!this.props.defaultOpen || !!this.props.open
    };
    this._id = uniqueId('__collapsibleSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }

  componentWillReceiveProps({
    open
  }) {
    if (open != null && open !== this.state.open) {
      this.setState({
        open
      });
    }
  }

  render() {
    const {
      label,
      title,
      rtl,
      variant,
      children,
      className,
      style,
      labelStyle,
      autoUnmount,
      ...others
    } = this.props;
    const {
      open
    } = this.state;
    const regionId = `${this._id}_region`;
    const {
      propertiesPanePassthroughProps,
      others: theRest
    } = getPassThroughProps(others, _PropertiesPane.default);
    const {
      collapsePassthroughProps,
      others: buttonPassthoughProps
    } = getPassThroughProps(theRest, _collapse.default);

    const labelNode = /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({}, buttonPassthoughProps, {
      className: `${collapsibleSectionClassName}__trigger-button`,
      "data-tid": "ba-common-collapse-section__trigger-button",
      id: this._id,
      kind: "ghost",
      size: "field",
      renderIcon: props => /*#__PURE__*/_react.default.createElement(_svgicon.default, (0, _extends2.default)({
        icon: _chevronRight_.default,
        rotate: open ? -90 : 90
      }, props)),
      onClick: this._toggleOpen,
      onKeyDown: this._onKeyDown,
      "aria-controls": regionId,
      "aria-expanded": open,
      "aria-labelledby": this._propLabelId,
      style: labelStyle
    }), label);

    return /*#__PURE__*/_react.default.createElement(_container.default, (0, _extends2.default)({}, sanitize(others, CollapsibleSection), {
      className: `ba-common-collapsibleSection ${className}`,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, propertiesPanePassthroughProps, {
      label: labelNode,
      title: title,
      rtl: rtl,
      htmlFor: this._id,
      labelSize: "full",
      labelId: this._propLabelId,
      variant: variant
    })), /*#__PURE__*/_react.default.createElement(_collapse.default, (0, _extends2.default)({}, collapsePassthroughProps, {
      autoUnmount: autoUnmount,
      isOpened: open,
      id: regionId
    }), children));
  }

}

exports.default = CollapsibleSection;
(0, _defineProperty2.default)(CollapsibleSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  children: _propTypes.default.node.isRequired,
  title: _propTypes.default.string,
  defaultOpen: _propTypes.default.bool,
  open: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(['normal', 'header']),
  onOpen: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  labelStyle: _propTypes.default.object,
  autoUnmount: _propTypes.default.bool,
  ...omit(_collapse.default.propTypes, 'isOpened')
});
(0, _defineProperty2.default)(CollapsibleSection, "defaultProps", {
  variant: 'normal',
  className: '',
  style: {},
  labelStyle: {}
});

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _label = _interopRequireDefault(__webpack_require__(17));

var _container = _interopRequireDefault(__webpack_require__(15));

var _utils = __webpack_require__(5);

var _SectionStyles = _interopRequireDefault(__webpack_require__(20));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const labelSectionClassName = _SectionStyles.default.labelSectionClassName.replace(/"/g, '');

const {
  sanitize
} = _utils.propsUtils;

class LabelSection extends _react.Component {
  render() {
    const {
      label,
      rtl,
      isSectionHeader,
      disabled,
      className,
      style,
      ...others
    } = this.props;
    const classNames = (0, _utils.classnames)(labelSectionClassName, isSectionHeader ? 'sectionHeader' : '');
    return /*#__PURE__*/_react.default.createElement(_container.default, (0, _extends2.default)({
      className: `${classNames} ${className}`,
      textAlign: rtl ? 'left' : 'right',
      style: style
    }, sanitize(others, LabelSection)), /*#__PURE__*/_react.default.createElement(_label.default, (0, _extends2.default)({}, others, {
      label: label,
      disabled: disabled
    })));
  }

}

exports.default = LabelSection;
(0, _defineProperty2.default)(LabelSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  isSectionHeader: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._label.default.propTypes
});
(0, _defineProperty2.default)(LabelSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(3);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(2));

var _propTypes = _interopRequireDefault(__webpack_require__(4));

var _utils = __webpack_require__(5);

var _button = _interopRequireDefault(__webpack_require__(12));

var _svgicon = _interopRequireDefault(__webpack_require__(10));

var _chevronRight_ = _interopRequireDefault(__webpack_require__(82));

var _SectionStyles = _interopRequireDefault(__webpack_require__(20));

var _PropertiesPane = _interopRequireDefault(__webpack_require__(19));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
const linkSectionClassName = _SectionStyles.default.linkSectionClassName.replace(/"/g, '');

const {
  uniqueId
} = _utils.lodash;
const {
  sanitize,
  getPassThroughProps
} = _utils.propsUtils;

class LinkSection extends _react.Component {
  constructor(props) {
    super(props);
    this._id = uniqueId('__linkSection_');
    this._propLabelId = `${this._id}_propLabel_`;
  }

  render() {
    const {
      label,
      value,
      title,
      disabled,
      rtl,
      dataLabel,
      onClick,
      labelSize,
      className,
      style,
      ...others
    } = this.props;
    const buttonIcon = {
      [rtl ? 'iconLeft' : 'iconRight']: rtl ? /*#__PURE__*/_react.default.createElement(_svgicon.default, {
        focusable: false,
        iconId: _chevronRight_.default.id,
        rotate: 180
      }) : /*#__PURE__*/_react.default.createElement(_svgicon.default, {
        focusable: false,
        iconId: _chevronRight_.default.id
      })
    };
    const {
      propertiesPanePassthroughProps,
      others: buttonPassthroughProps
    } = getPassThroughProps(others, _PropertiesPane.default);
    return /*#__PURE__*/_react.default.createElement(_PropertiesPane.default, (0, _extends2.default)({}, sanitize(others, LinkSection), propertiesPanePassthroughProps, {
      className: `${linkSectionClassName} ${className}`,
      label: label,
      rtl: rtl,
      disabled: disabled,
      htmlFor: this._id,
      labelSize: labelSize,
      labelId: this._propLabelId,
      dataLabel: dataLabel,
      style: style
    }), /*#__PURE__*/_react.default.createElement(_button.default // {...buttonPassThroughProps}}// TODO: uncomment this line and remove next line when icon is deprecated
    , (0, _extends2.default)({}, sanitize(buttonPassthroughProps, null, 'icon'), buttonIcon, {
      role: "link",
      "data-tid": "ba-common-link-section__button-link",
      "aria-label": title,
      intent: "primary",
      ellipsis: true,
      id: this._id,
      variant: "inline",
      label: value,
      disabled: disabled,
      onClick: onClick,
      title: title,
      "aria-labelledby": title ? null : this._propLabelId
    })));
  }

}

exports.default = LinkSection;
(0, _defineProperty2.default)(LinkSection, "propTypes", {
  label: _propTypes.default.string.isRequired,
  value: _propTypes.default.string,
  labelSize: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),
  title: _propTypes.default.string,
  // todo
  // currently title is used for the title of the link
  // we may need two titles - one for the property, and one for the link
  disabled: _propTypes.default.bool,
  rtl: _propTypes.default.bool,
  dataLabel: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  ..._button.default.propTypes,
  ..._PropertiesPane.default.propTypes
});
(0, _defineProperty2.default)(LinkSection, "defaultProps", {
  className: '',
  style: {}
});

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__46__;

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__47__;

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__48__;

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__49__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__5__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 60:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/chevron--right_32");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/information_16");

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__79__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__80__;

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__81__;

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/chevron--right_32.js");

/***/ })

},[[434,0]]]);
});